var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPositiveLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 445.956,
    height: 74.102,
    viewBox: "0 0 445.956 74.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.185,
    y1: 1.18,
    x2: 0.815,
    y2: 0.393,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a96903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#aa6a02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#b07102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#b97d02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#c78e01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#daa401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557,
    stopColor: "#f0be00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579,
    stopColor: "#ffd100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a96903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.423,
    y1: -5.972,
    x2: 1.438,
    y2: 7.076,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.638,
    y1: -7.482,
    x2: 1.222,
    y2: 5.566,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.853,
    y1: -8.992,
    x2: 1.007,
    y2: 4.056,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_463",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 463",
    transform: "translate(12492.149 5219.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_102",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 102",
    transform: "translate(-12491.734 -5219.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_95",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 95",
    d: "M3324.594-541.943a57.005,57.005,0,0,1-17.927-2.957l-.492-.162.978-2.954.493.163a53.9,53.9,0,0,0,16.948,2.8c14.315,0,15.861-4.8,15.861-6.868,0-3.951-4.738-4.853-15.357-5.381-8.24-.37-18.5-.831-18.5-8.951,0-5.864,5.978-9.227,16.4-9.227a81.733,81.733,0,0,1,16.591,1.852l.506.112-.672,3.039-.506-.112A78.413,78.413,0,0,0,3323-572.369c-8.445,0-13.288,2.228-13.288,6.115,0,4.766,6.73,5.447,15.529,5.842,9.011.448,18.325.91,18.325,8.489C3343.567-548.922,3341.718-541.943,3324.594-541.943Z",
    transform: "translate(-3306.176 578.114)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_96",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 96",
    d: "M3929.826-540.546c-13.284,0-19.471-4.359-19.471-13.718v-18.315h3.112v18.315c0,7.434,4.893,10.606,16.359,10.606s16.363-3.172,16.363-10.606v-18.315h3.112v18.315C3949.3-544.906,3943.114-540.546,3929.826-540.546Z",
    transform: "translate(-3596.988 576.717)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_97",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 97",
    d: "M3441.649-545.9v-26.288l-19.777,22.923-19.782-22.923V-545.9h-3.112v-34.658l22.894,26.529,22.888-26.53V-545.9Z",
    transform: "translate(-3350.844 580.558)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_98",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 98",
    d: "M3527.334-572.284l-18.652,28.407-2.6-1.708,21.252-32.369,21.254,32.369-2.6,1.708Z",
    transform: "translate(-3402.397 579.304)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_99",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 99",
    d: "M3619.877-556.531h12.266c6.415,0,9.533-2.428,9.533-7.423,0-5.127-3.037-7.515-9.559-7.515h-22.09v28.447h-3.112v-31.559h25.2c10.472,0,12.671,5.779,12.671,10.627,0,3.935-1.643,10.535-12.646,10.535H3630l13.092,8.886-1.748,2.575Z",
    transform: "translate(-3450.932 577.681)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_151",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 151",
    width: 35.513,
    height: 3.112,
    transform: "translate(203.379 3.101)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_152",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 152",
    width: 3.112,
    height: 30.52,
    transform: "translate(219.579 4.138)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_100",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 100",
    d: "M3825.316-540.924v-31.452h3.112v28.34h29.434v3.112Z",
    transform: "translate(-3556.057 576.62)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_153",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 153",
    width: 3.113,
    height: 46.404,
    transform: "translate(363.748 5.507) rotate(-49.475)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_154",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 154",
    width: 46.404,
    height: 3.113,
    transform: "matrix(0.76, -0.65, 0.65, 0.76, 363.75, 33.296)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_155",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 155",
    width: 33.093,
    height: 3.112,
    transform: "translate(412.448 3.101)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_156",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 156",
    width: 33.093,
    height: 3.112,
    transform: "translate(412.448 17.844)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_157",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 157",
    width: 33.093,
    height: 3.112,
    transform: "translate(412.448 32.587)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_462",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 462",
    transform: "translate(-12492.149 -5160.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_101",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 101",
    d: "M3456.88-451.4l-7.281-5.759v5.759h-1.7v-13.644h6.275c3.008,0,4.876,1.528,4.876,3.988,0,2.528-1.748,3.978-4.795,3.978h-1.992l7.326,5.678Zm-2.625-7.279c1.142,0,3.06-.309,3.06-2.377,0-2.154-2.14-2.386-3.06-2.386H3449.6v4.763Z",
    transform: "translate(-3447.898 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_102",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 102",
    d: "M3476.763-451.4v-13.643h10.654v1.592h-8.96v3.9l6.681,0v1.575h-6.681v4.969h8.965v1.607Z",
    transform: "translate(-3461.792 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_103",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 103",
    d: "M3507.856-466.527l7.648,14.438h-1.869l-1.711-3.292h-8.2l-1.755,3.294h-1.9Zm3.265,9.623-3.28-6.256-3.311,6.256Z",
    transform: "translate(-3473.01 466.527)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_104",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 104",
    d: "M3534.45-451.4v-13.643h1.7l-.007,12.037h8.144v1.606Z",
    transform: "translate(-3489.561 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_105",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 105",
    d: "M3572.289-451.4v-13.643h10.653v1.592h-8.96v3.9l6.681,0v1.575h-6.681v4.969h8.965v1.607Z",
    transform: "translate(-3507.774 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_106",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 106",
    d: "M3603.224-451.387a11.612,11.612,0,0,1-6-1.608l-.228-.145.936-1.348.209.128a10.111,10.111,0,0,0,5.082,1.376h.107c2.229-.028,3.616-.881,3.619-2.225,0-1.162-.686-1.661-3.072-2.225l-1.838-.432c-2.973-.694-4.3-1.854-4.321-3.762-.019-2.159,2.073-3.631,5.206-3.662h.092a9.783,9.783,0,0,1,5.093,1.439l.224.142-.9,1.358-.215-.135a7.747,7.747,0,0,0-4.077-1.207h-.112c-2.232.039-3.556.821-3.541,2.09.014,1.066.861,1.679,3.023,2.186l1.909.443c3.012.7,4.246,1.784,4.262,3.75a3.211,3.211,0,0,1-.947,2.327,6.227,6.227,0,0,1-4.444,1.511Z",
    transform: "translate(-3519.665 465.933)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_107",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 107",
    d: "M3628.242-451.4v-12.037h-5l-.009-1.606h11.689v1.606h-4.985V-451.4Z",
    transform: "translate(-3532.296 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_108",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 108",
    d: "M3652.924-466.527l7.649,14.438h-1.87l-1.711-3.292h-8.2l-1.755,3.294h-1.9Zm3.265,9.623-3.279-6.256L3649.6-456.9Z",
    transform: "translate(-3542.838 466.527)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_109",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 109",
    d: "M3678.851-451.4v-12.037h-5l-.009-1.606h11.689v1.606h-4.984V-451.4Z",
    transform: "translate(-3556.655 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_110",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 110",
    d: "M3702.293-451.4v-13.643h10.653v1.592h-8.959v3.9l6.681,0v1.575h-6.681v4.969h8.965v1.607Z",
    transform: "translate(-3570.348 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_111",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 111",
    d: "M3742.9-451.407V-465.05l4.714-.009c4.609,0,7.689,2.753,7.689,6.85,0,4.068-3.089,6.8-7.688,6.8Zm1.694-1.592,3.018,0c3.753,0,5.994-1.949,5.994-5.205,0-3.279-2.241-5.242-5.995-5.25l-3.017,0Z",
    transform: "translate(-3589.895 465.821)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_112",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 112",
    d: "M3779.971-451.378a7.08,7.08,0,0,1-7.26-7.049,7.09,7.09,0,0,1,7.26-7.068,7.1,7.1,0,0,1,7.286,7.068A7.094,7.094,0,0,1,3779.971-451.378Zm0-12.487a5.443,5.443,0,0,0-5.562,5.44,5.431,5.431,0,0,0,5.562,5.414,5.447,5.447,0,0,0,5.592-5.414A5.4,5.4,0,0,0,3779.967-463.865Z",
    transform: "translate(-3604.244 466.03)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_113",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 113",
    d: "M3818.928-451.4l-9.129-10.993V-451.4h-1.7v-13.641h1.576l9.143,11.018v-11.022h1.7V-451.4Z",
    transform: "translate(-3621.277 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_114",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 114",
    d: "M3840.838-451.4v-13.643h10.655v1.592h-8.96v3.9l6.681,0v1.575h-6.681v4.969h8.965v1.607Z",
    transform: "translate(-3637.037 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_115",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 115",
    d: "M3885.532-451.387a11.614,11.614,0,0,1-6-1.608l-.227-.145.935-1.348.209.128a10.113,10.113,0,0,0,5.082,1.376h.108c2.229-.028,3.616-.881,3.618-2.225,0-1.162-.685-1.661-3.073-2.225l-1.837-.432c-2.972-.694-4.3-1.854-4.322-3.762-.018-2.159,2.074-3.631,5.206-3.662h.093a9.774,9.774,0,0,1,5.092,1.439l.225.142-.9,1.358-.214-.135a7.75,7.75,0,0,0-4.077-1.207h-.111c-2.234.039-3.558.821-3.542,2.09.013,1.066.861,1.679,3.023,2.186l1.908.443c3.012.7,4.247,1.784,4.262,3.75a3.2,3.2,0,0,1-.946,2.326,6.224,6.224,0,0,1-4.444,1.511Z",
    transform: "translate(-3655.55 465.933)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_116",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 116",
    d: "M3910.54-461.436V-451.4h-1.694v-13.64h1.593l5.756,10.841,5.8-10.842h1.566V-451.4h-1.694v-10.026l-5.66,10.572Z",
    transform: "translate(-3669.77 465.811)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_117",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 117",
    d: "M3949.625-466.527l7.649,14.438h-1.87l-1.711-3.292h-8.2l-1.757,3.294h-1.9Zm3.265,9.623-3.28-6.256L3946.3-456.9Z",
    transform: "translate(-3685.65 466.527)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_118",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 118",
    d: "M3985.2-451.4l-7.281-5.759v5.759h-1.7v-13.644h6.276c3.006,0,4.875,1.528,4.875,3.988,0,2.528-1.748,3.978-4.8,3.978h-1.991l7.326,5.678Zm-2.625-7.279c1.142,0,3.06-.309,3.06-2.377,0-2.154-2.14-2.386-3.06-2.386h-4.656v4.763Z",
    transform: "translate(-3702.198 465.813)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_119",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 119",
    d: "M4006.946-451.4v-12.037h-5l-.009-1.606h11.689v1.606h-4.986V-451.4Z",
    transform: "translate(-3714.578 465.813)",
    fill: "#161615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPositiveLeft);
export default __webpack_public_path__ + "static/media/logo_positive_left.3f271176d47be586afd482a953f3de76.svg";
export { ForwardRef as ReactComponent };